$(document).ready(function () {
  // Prepend General Message Banner to Header
  $('.generalmessage').prependTo('header');

  // Append mobile Search
  $('.search-container').appendTo('.mobile-menu-footer-links');

  // Move mobile nav ticket button

  $('.mobile-menu-container .mobile-menu-ticket-btn').appendTo('.mobile-menu-subheader');

  // Mobile Search

  const inputElement = document.querySelector('.mobile-menu-container .search-container input[type=text]');
  inputElement.removeAttribute('placeholder');

  // Mobile Countdown

  setTimeout(function() {
    var originalWidget = $('#siteInfoBannerWidget');
    var clonedWidget = originalWidget.clone();

    clonedWidget.attr('id', 'clonedSiteInfoBannerWidget');
    clonedWidget.addClass('mobile-countdown');
    
    $('.mobile-menu-container .mobile-menu-subheader').append(clonedWidget);
  }, 2000);

});

$(window).load(function () {
  // ---

});


// test